import { createClient } from '@supabase/supabase-js';

// Supabase trusts Clerk's JWKS via Third-Party Auth (configured in Supabase dashboard).
// On every request, this getter pulls the current Clerk session token; RLS policies
// then read `auth.jwt() ->> 'sub'` to identify the Clerk user.
async function getClerkToken() {
  try {
    return (await window.Clerk?.session?.getToken()) ?? null;
  } catch {
    return null;
  }
}

export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY,
  { accessToken: getClerkToken }
);

// Sensitive-operation audit log helper. Fire-and-forget — never blocks the
// user action or surfaces errors. The RPC itself enforces caller membership
// + locks the action code format, so we can call it freely from the UI.
// Call sites should pass the smallest brand_id scope (null only for true
// agency-level events). target_type/target_id let us link back to the row
// that was affected during incident review.
export async function logSecurityEvent(brandId, action, targetType, targetId, details) {
  try {
    await supabase.rpc('log_security_event', {
      p_brand_id: brandId || null,
      p_action: action,
      p_target_type: targetType || null,
      p_target_id: targetId ? String(targetId) : null,
      p_details: details || {},
    });
  } catch (e) {
    // Audit log failure must never break the user-facing action.
    console.warn('logSecurityEvent failed', action, e);
  }
}
